var _rect, _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgInactiveWeb(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 43,
    height: 42,
    viewBox: "0 0 43 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 42.1417,
    height: 42,
    rx: 10,
    fill: "#EBEBEB"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_602_9)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M27.8537 33.0825C23.2068 33.6001 18.4035 33.6001 13.7566 33.0825C12.012 32.8881 10.4803 31.9478 9.51147 30.5822L21.5577 18.5767L25.2747 22.2811C25.7155 22.7204 26.4302 22.7204 26.871 22.2811C27.3118 21.8417 27.3118 21.1295 26.871 20.6902L22.3558 16.1902C21.915 15.7508 21.2004 15.7508 20.7595 16.1902L8.54523 28.3633C8.51151 28.1989 8.48442 28.032 8.46455 27.8629C7.90889 23.1275 7.90889 18.3437 8.46456 13.6084C8.78799 10.8529 11.0078 8.69498 13.7566 8.38868C18.4035 7.87118 23.2068 7.87118 27.8537 8.38868C30.6025 8.69498 32.8224 10.8529 33.1457 13.6084C33.7014 18.3437 33.7014 23.1275 33.1457 27.8629C32.8224 30.6183 30.6025 32.7763 27.8537 33.0825Z",
    fill: "#B51D1D"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_602_9)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M33.1935 13.7111C33.7128 18.3424 33.7128 23.1295 33.1935 27.7608C32.9985 29.4996 32.055 31.0261 30.6848 31.9917L18.6387 19.986L22.3556 16.2815C22.7965 15.8421 22.7965 15.1298 22.3556 14.6905C21.9148 14.2511 21.2002 14.2511 20.7594 14.6905L16.2442 19.1905C15.8034 19.6299 15.8034 20.3421 16.2442 20.7814L28.4584 32.9547C28.2934 32.9883 28.126 33.0153 27.9563 33.0351C23.2049 33.5889 18.405 33.5889 13.6537 33.0351C10.8889 32.7127 8.72372 30.5004 8.41639 27.7608C7.89714 23.1295 7.89714 18.3424 8.41639 13.7111C8.72372 10.9715 10.8889 8.75914 13.6537 8.43687C18.405 7.88302 23.2049 7.88302 27.9563 8.43687C30.721 8.75914 32.8863 10.9715 33.1935 13.7111Z",
    fill: "#B51D1D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 12.7783,
    y: 13.7344,
    width: 15.0506,
    height: 15,
    fill: "#B51D1D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.8926 26.6269L26.7174 14.8418",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.8926 14.8418L26.7174 26.6268",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_602_9"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 36.1214,
    height: 36,
    fill: "white",
    transform: "translate(39.1318 36) rotate(-180)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_602_9"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36.1214,
    fill: "white",
    transform: "translate(39.1318) rotate(90)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInactiveWeb);
export default __webpack_public_path__ + "static/media/inactive_web.7648da71bfb8fba174773b1690740091.svg";
export { ForwardRef as ReactComponent };